// 招待メールを送る。登録そのものは終わっているので、失敗しても画面は止めず知らせるだけ
import type { InviteResult } from '@torapon/shared';
import { api, HttpError } from './api';

export async function sendInvite(kind: 'driver' | 'staff', id: string, toast: (m: string) => void) {
  try {
    const r = await api.post<InviteResult>('/v1/office/invites', { kind, id });
    if (r.sent) toast('招待メールを送りました');
  } catch (e) {
    toast(e instanceof HttpError ? `招待メールを送れませんでした：${e.message}` : '招待メールを送れませんでした');
  }
}
